import React, { Component } from "react";
import IntegratorsTable from "./Table";
import CircularProgress from "material-ui/CircularProgress";
import styles from "styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getIntegrators } from "actions/integrators/integrators";
class IntegratorsListPage extends Component {
  componentDidMount() {
    const { getIntegrators } = this.props;
    getIntegrators();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <div id="integrators-list" className="table-page">
        <CircularProgress
          className={!isLoaded ? "" : "hidden"}
          style={styles.circularProgress}
        />

        <div className={isLoaded ? "" : "hidden"}>
          <div className="container-fluid">
            <h2>List of Integrators</h2>
            <IntegratorsTable />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ integrators }) => {
    return {
      isLoaded: integrators.isLoaded,
      integrators: integrators.data,
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        getIntegrators,
      },
      dispatch
    )
)(IntegratorsListPage);



// WEBPACK FOOTER //
// ./app/components/Integrators/List/Page.jsx